import { Config } from '../config';
import { isNotDev } from './isNotProd';
import { Event } from '../interfaces';
import { Alert } from '../components/atoms';

export const gotoEventS3 = (event: Event) => async () => {
  // if is localhost use the Config.INSTANCE, otherwise use the hostname from the window
  const destination = !isNotDev() ? Config.INSTANCE : Config.StageName;
  const video = event.event_videos?.[0] || event.sub_events?.[0]?.event_videos[0];
  const path = video.s3_key.split('/');
  const s3key = [...path].splice(0, 4).join('/');

  await new Alert('Event prefix will be copied to clipboard. Paste it in s3 console.').promise;

  navigator.clipboard.writeText(path[4].replace('.mp4', '')).then(() => {
    window.open(
      `https://us-west-2.console.aws.amazon.com/s3/buckets/ai-hayden-event-video-${destination}?region=us-west-2&bucketType=general&prefix=${s3key}/&showversions=false`,
    );
  });
};
